
/***
 * Son els tipñus de solucions amb les que treballem
 */
export enum Solutions {
    desktop = "desktop",
    mobile = "mobile",
    tablet = "tablet"
}